(function(window, angular) {
	'use strict';
	
	var animateOnChangeModule = angular.module('animateOnChangeModule', []);

})(window, window.angular);